import { render, staticRenderFns } from "./dealConfig.vue?vue&type=template&id=369a6400&scoped=true&"
import script from "./dealConfig.vue?vue&type=script&lang=ts&"
export * from "./dealConfig.vue?vue&type=script&lang=ts&"
import style0 from "./dealConfig.vue?vue&type=style&index=0&id=369a6400&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369a6400",
  null
  
)

export default component.exports